let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fAT4w")).then(() => parcelRequire('g1kwn'));